import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/logo/LogoYellow.svg'
import _imports_1 from '@/assets/images/LoginImage.png'


const _hoisted_1 = { class: "wrapper-login" }
const _hoisted_2 = { class: "wrapper-form" }
const _hoisted_3 = { class: "container" }
const _hoisted_4 = { class: "container-inputs" }
const _hoisted_5 = { class: "wrapper-buttons" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LoginInput = _resolveComponent("LoginInput")!
  const _component_LoginButton = _resolveComponent("LoginButton")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[3] || (_cache[3] = _createElementVNode("img", {
          src: _imports_0,
          alt: "",
          class: "logo"
        }, null, -1)),
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_LoginInput, {
            text: _ctx.userName.val,
            "onUpdate:text": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.userName.val) = $event)),
            value: _ctx.userName.val,
            label: 'Nombre de usuario',
            "has-error": _ctx.userName.enabled,
            error: _ctx.userName.errors.length === 0 ? '' : _ctx.userName.errors[0]
          }, null, 8, ["text", "value", "has-error", "error"]),
          _createVNode(_component_LoginInput, {
            text: _ctx.password.val,
            "onUpdate:text": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.password.val) = $event)),
            value: _ctx.password.val,
            label: 'Contraseña',
            "has-error": _ctx.password.enabled,
            error: _ctx.password.errors.length === 0 ? '' : _ctx.password.errors[0],
            "is-password": "true"
          }, null, 8, ["text", "value", "has-error", "error"])
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_LoginButton, {
            buttonLabel: 'Ingresar',
            onClick: _ctx.loginTransaction,
            "is-disabled": _ctx.successForm
          }, null, 8, ["onClick", "is-disabled"]),
          _cache[2] || (_cache[2] = _createElementVNode("a", {
            href: "/store",
            class: "download-link",
            target: "_blank"
          }, "Descargar app para Android", -1))
        ])
      ])
    ]),
    _cache[4] || (_cache[4] = _createElementVNode("div", { class: "wrapper-image" }, [
      _createElementVNode("img", {
        src: _imports_1,
        alt: "",
        class: "image"
      })
    ], -1))
  ]))
}